import { useEffect } from 'react';

/**
 * Hook to manage iubenda cookie consent integration
 * Handles consent callbacks and updates Google Analytics consent accordingly
 */
export const useIubendaConsent = (language: 'en' | 'it') => {
  useEffect(() => {
    // Update iubenda language when app language changes
    if (typeof window !== 'undefined' && window._iub) {
      // Update language in configuration if it exists
      if (!Array.isArray(window._iub) && window._iub.csConfiguration) {
        window._iub.csConfiguration.lang = language;
      }
    }
  }, [language]);

  useEffect(() => {
    // Listen for consent changes (for debugging/analytics purposes)
    const handleConsentGiven = () => {
      console.log('iubenda: Consent given');
    };

    const handleConsentRejected = () => {
      console.log('iubenda: Consent rejected');
    };

    // Add event listeners if iubenda provides them
    if (typeof window !== 'undefined') {
      window.addEventListener('iubenda_consent_given', handleConsentGiven);
      window.addEventListener('iubenda_consent_rejected', handleConsentRejected);

      return () => {
        window.removeEventListener('iubenda_consent_given', handleConsentGiven);
        window.removeEventListener('iubenda_consent_rejected', handleConsentRejected);
      };
    }
  }, []);
};
